import { MuiChartType } from '@verantos-dev/shared-components';
import { CohortCharacteristicsResultType } from '@verantos-dev/types-cohorts';

export const cohortCharacteristicResultTypeToTabularSectionNameMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ageAtIndexSection',
  [CohortCharacteristicsResultType.ETHNICITY]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ethnicitySection',
  [CohortCharacteristicsResultType.GENDER]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.genderSection',
  [CohortCharacteristicsResultType.RACE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.raceSection',
  [CohortCharacteristicsResultType.EVENT_DISTRIBUTION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.eventDistributionSection',
  [CohortCharacteristicsResultType.KPI]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.kpiSection',

  [CohortCharacteristicsResultType.CC_CONDITION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccCondition',
  [CohortCharacteristicsResultType.CC_DRUG]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccDrug',
  [CohortCharacteristicsResultType.CC_MEASUREMENT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccMeasurement',
  [CohortCharacteristicsResultType.CC_OBSERVATION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccObservation',
  [CohortCharacteristicsResultType.CC_PROCEDURE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccProcedure',
  [CohortCharacteristicsResultType.CC_VISIT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccVisit',
};

export const cohortCharacteristicResultTypeToSectionNameMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ageAtIndex',
  [CohortCharacteristicsResultType.ETHNICITY]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ethnicity',
  [CohortCharacteristicsResultType.GENDER]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.gender',
  [CohortCharacteristicsResultType.RACE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.race',
  [CohortCharacteristicsResultType.EVENT_DISTRIBUTION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.eventDistribution',
  [CohortCharacteristicsResultType.KPI]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.kpi',

  [CohortCharacteristicsResultType.CC_CONDITION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccCondition',
  [CohortCharacteristicsResultType.CC_DRUG]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccDrug',
  [CohortCharacteristicsResultType.CC_MEASUREMENT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccMeasurement',
  [CohortCharacteristicsResultType.CC_OBSERVATION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccObservation',
  [CohortCharacteristicsResultType.CC_PROCEDURE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccProcedure',
  [CohortCharacteristicsResultType.CC_VISIT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccVisit',
};

export const cohortCharacteristicResultTypeToCustomSectionNameMap = {
  [CohortCharacteristicsResultType.CC_CONDITION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccCondition.custom',
  [CohortCharacteristicsResultType.CC_DRUG]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccDrug.custom',
  [CohortCharacteristicsResultType.CC_MEASUREMENT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccMeasurement.custom',
  [CohortCharacteristicsResultType.CC_OBSERVATION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccObservation.custom',
  [CohortCharacteristicsResultType.CC_PROCEDURE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccProcedure.custom',
  [CohortCharacteristicsResultType.CC_VISIT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccVisit.custom',
};

export const cohortCharacteristicResultTypeToDefaultChartTypeMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]: MuiChartType.BAR,
  [CohortCharacteristicsResultType.ETHNICITY]: MuiChartType.DONUT,
  [CohortCharacteristicsResultType.GENDER]: MuiChartType.DONUT,
  [CohortCharacteristicsResultType.RACE]: MuiChartType.DONUT,
};

export const cohortCharacteristicResultTitleEmptyMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ageAtIndex',
  [CohortCharacteristicsResultType.ETHNICITY]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ethnicity',
  [CohortCharacteristicsResultType.GENDER]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.gender',
  [CohortCharacteristicsResultType.RACE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.race',
  [CohortCharacteristicsResultType.EVENT_DISTRIBUTION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.eventDistribution',
  [CohortCharacteristicsResultType.KPI]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.kpi',

  [CohortCharacteristicsResultType.CC_CONDITION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccCondition',
  [CohortCharacteristicsResultType.CC_DRUG]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccDrug',
  [CohortCharacteristicsResultType.CC_MEASUREMENT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccMeasurement',
  [CohortCharacteristicsResultType.CC_OBSERVATION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccObservation',
  [CohortCharacteristicsResultType.CC_PROCEDURE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccProcedure',
  [CohortCharacteristicsResultType.CC_VISIT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccVisit',
};

export const cohortCharacteristicResultMessageeEmptyMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ageAtIndex',
  [CohortCharacteristicsResultType.ETHNICITY]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ethnicity',
  [CohortCharacteristicsResultType.GENDER]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.gender',
  [CohortCharacteristicsResultType.RACE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.race',
  [CohortCharacteristicsResultType.EVENT_DISTRIBUTION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.eventDistribution',
  [CohortCharacteristicsResultType.KPI]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.kpi',

  [CohortCharacteristicsResultType.CC_CONDITION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccCondition',
  [CohortCharacteristicsResultType.CC_DRUG]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccDrug',
  [CohortCharacteristicsResultType.CC_MEASUREMENT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccMeasurement',
  [CohortCharacteristicsResultType.CC_OBSERVATION]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccObservation',
  [CohortCharacteristicsResultType.CC_PROCEDURE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccProcedure',
  [CohortCharacteristicsResultType.CC_VISIT]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccVisit',
};

// Conditions, Drugs, Measurements, Observations, Procedures, Visits

export const ClinicalCharacteristicsDomainOptions = [
  {
    value: 'ccCondition',
    displayValue: 'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccCondition',
  },
  {
    value: 'ccDrug',
    displayValue: 'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccDrug',
  },
  {
    value: 'ccMeasurement',
    displayValue: 'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccMeasurement',
  },
  {
    value: 'ccObservation',
    displayValue: 'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccObservation',
  },
  {
    value: 'ccProcedure',
    displayValue: 'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccProcedure',
  },
  {
    value: 'ccVisit',
    displayValue: 'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccVisit',
  },
];

export const CharacteristicTypeOptions = [
  {
    value: 'Clinical',
    displayValue: 'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.clinical',
  },
  {
    value: 'Demographics',
    displayValue: 'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.demographics',
  },
];
